import React from 'react';

const EventContext = React.createContext({
  publish: () => {},
  subscribe: () => {},
  unsubscribe: () => {}
});
const EventContextConsumer = EventContext.Consumer;
class EventContextProvider extends React.Component {
  constructor(props) {
    super(props);

    this.publish = event => {
      this.state[event.eventType] && this.state[event.eventType].forEach(handler => handler(event));
    };

    this.subscribe = ({
      eventType,
      handler
    }) => {
      this.setState(state => {
        if (!state[eventType] || !state[eventType].includes(handler)) {
          return { ...state,
            [eventType]: state[eventType] && state[eventType].push(handler) && state[eventType] || [handler]
          };
        }

        return { ...state
        };
      });
    };

    this.unsubscribe = ({
      eventType,
      handler
    }) => {
      this.setState(state => {
        if (state[eventType] && state[eventType].includes(handler)) {
          return { ...state,
            [eventType]: state[eventType].filter(ehandler => ehandler !== handler)
          };
        }

        return { ...state
        };
      });
    };

    this.state = {};
  }

  render() {
    return /*#__PURE__*/React.createElement(EventContext.Provider, {
      value: {
        publish: this.publish,
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe
      }
    }, this.props.children);
  }

}

class TestConsumerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.context = void 0;
  }

  componentDidMount() {
    this.props.bindings.forEach(binding => this.context.subscribe(binding));
  }

  componentWillUnmount() {
    this.props.bindings.forEach(binding => this.context.unsubscribe(binding));
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

}
TestConsumerComponent.contextType = EventContext;
const EventTester = ({
  children,
  bindings
}) => /*#__PURE__*/React.createElement(EventContextProvider, null, children, /*#__PURE__*/React.createElement(TestConsumerComponent, {
  bindings: bindings
}));

export { EventContext, EventContextConsumer, EventContextProvider, EventTester, TestConsumerComponent };
//# sourceMappingURL=index.js.map
